import {  Injectable                                                                } from '@angular/core';
import {  ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import {  Observable                                                                } from 'rxjs';
import {  filter, map, take                                                         } from 'rxjs/operators';
import {  MicrosoftAuthService                                                      } from '../service/auth/microsoft-auth.service';
import {  UserInfo, UserService                                                     } from '../service/user.service';

@Injectable({
  providedIn: 'root'
})
export class RoleGuard implements CanActivate
{
  constructor(
    private _router       : Router,
    private userServices  : UserService,
    private authService   : MicrosoftAuthService
  )
  {}
  
  canActivate(
    next  : ActivatedRouteSnapshot,
    state : RouterStateSnapshot
  ) : Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree
  {
    return this.userServices.userInfo$.pipe(
      filter(user => user.rol !== null),
      take(1), 
      map(
        (userInfo : UserInfo) =>
        {
          const requiredRoles : string[]  = next.data['rolUsuario'];
          const userRol       : string    = userInfo.rol || '';
          const hasPermission : boolean   = requiredRoles.some(requiredRole => requiredRole == userRol);

          if (this.authService.isLoggedIn())
          {
            if (hasPermission)
              return true;
            
            return this._router.createUrlTree(['/']);
          }
          
          return this._router.createUrlTree(['/login']);
        }
      )
    );
  }
}
